// extracted by mini-css-extract-plugin
export default {"bannercarousel":"CarouselBanner_bannercarousel__2NOWK"};